import zxcvbn from "zxcvbn";

const labels = ["Sehr schwach", "Schwach", "Okay", "Gut", "Stark"];
const colors = ["#d32f2f", "#ef6c00", "#f9a825", "#43a047", "#2e7d32"]; // rot → grün

export default function PasswordStrengthMeter({ password, userInputs = [] }) {
  if (!password) return null;
  const { score, feedback } = zxcvbn(password, userInputs);
  const activeBars = Math.min(score + 1, 5);

  return (
    <div style={{marginTop:8}}>
      <div style={{display:"grid", gridTemplateColumns:"repeat(5, 1fr)", gap:6}}>
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i}
               style={{
                 height: 8,
                 borderRadius: 4,
                 background: i < activeBars ? colors[score] : "#e0e0e0",
                 transition: "background 150ms ease"
               }}/>
        ))}
      </div>
      <div style={{marginTop:6, fontSize:12, color: colors[score]}}>
        {labels[score]}
      </div>
      {(feedback?.warning || (feedback?.suggestions?.length)) && (
        <div style={{marginTop:6, fontSize:12, color:"#666"}}>
          {feedback.warning && <div>Hinweis: {feedback.warning}</div>}
          {feedback.suggestions?.length > 0 && (
            <ul style={{margin:"4px 0 0 16px", padding:0}}>
              {feedback.suggestions.map((s, idx) => <li key={idx}>{s}</li>)}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
